import { Helmet as HelmetAsync, type HelmetProps as HelmetAsyncProps } from "react-helmet-async";

type HelmetProps = HelmetAsyncProps & { children?: React.ReactNode };

export function Helmet(props: HelmetProps) {
	const { children, ...rest } = props;
	return <HelmetAsync {...rest}>{children}</HelmetAsync>;
}
